import React, { useContext } from 'react'

import { AlertContext } from './AlertContainer'
import AlertsHeader from './components/AlertsHeader'
import AlertsFilter from './components/AlertsFilter'
import AlertsTable from './components/AlertsTable'

import Spinner from 'components/CommonUI/Spinner/Spinner'
import { useShallowEqualSelector } from 'custom-hooks'
import { getIsFetchingAlertsSelector } from 'redux/reducers/alerts'

const AlertsPage = () => {
  const { state, actions } = useContext(AlertContext)

  return (
    <div className="page_container alerts_page_container">
      <AlertsHeader
        searchValue={state.searchValue}
        handleChange={actions.setSearchValue}
      />
      <AlertsFilter
        counts={state.statusCounts}
        facilitySelectValue={state.facilitySelectValue}
        facilityFilterOptions={state.facilityFilterOptions}
        devicesSelectValue={state.devicesSelectValue}
        deviceFilterOptions={state.devicesFilterOptions}
        handleChangeDeviceSelect={actions.setDevicesSelectValue}
        hadnleChangeFacilitySelect={actions.setFacilitySelectValue}
        handleChangeTab={actions.setStatusTabValue}
      />
      <AlertsTable data={state.filteringData} />
      <AlertsLoadind />
    </div>
  )
}

const AlertsLoadind = () => {
  const isFetching = useShallowEqualSelector(getIsFetchingAlertsSelector)
  return isFetching && <Spinner />
}

export default AlertsPage
